import clsx from "clsx";
import css from "./SortOrder.module.css";

export function SortOrder(props: { value: null | "asc" | "desc" }) {
  if (props.value === null) {
    return null;
  }
  return (
    <div
      className={clsx(css.root, {
        [css.asc]: props.value === "asc",
        [css.desc]: props.value === "desc",
      })}
    />
  );
}
